module.exports = {"id":"219576","name":"Rodrigo Battaglia","rating":"78","photo":"./data/images/photos/1/219576.png","club":{"name":"Sporting CP","logo":"./data/images/clubs/SportingCP.png"},"positions":["MC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RodrigoBattaglia0.json
// module id = 3664
// module chunks = 0